var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFooterIconFb = function SvgFooterIconFb(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3152 11H33.6752C34.0249 11 34.3604 11.1382 34.6086 11.3846C34.8568 11.631 34.9975 11.9655 35 12.3152V33.6752C35 34.0266 34.8604 34.3635 34.612 34.612C34.3635 34.8604 34.0266 35 33.6752 35H27.56V25.7192H30.68L31.16 22.0856H27.5696V19.772C27.5696 18.7291 27.8618 18.0095 29.3625 18.008H31.2632L31.2728 18.008V14.768C30.376 14.6714 29.4747 14.6233 28.5728 14.6238M28.4696 14.624C25.7048 14.624 23.8112 16.304 23.8112 19.412V22.0856L20.7008 22.0856L20.6912 22.0856V25.7192H23.8112V35L12.3248 35C11.9751 35 11.6396 34.8618 11.3914 34.6154C11.1432 34.369 11.0025 34.0345 11 33.6848V12.3248C11 11.9751 11.1382 11.6396 11.3846 11.3914C11.631 11.1432 11.9655 11.0025 12.3152 11"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFooterIconFb);
export default ForwardRef;